import { Dayjs } from 'dayjs';

export type DeliveryDetailUi = {
  orderNumber?: string;
  deliveryDate: Dayjs | null;
  deliveryDateError?: string;
  deliveryStartTime: Dayjs | null;
  deliveryEndTime: Dayjs | null;
  deliveryNotes: string;
  deliveryEndTimeError?: string;
  isEditable?: boolean;
  showPlaceholders?: boolean;
  saveDisabled: boolean;
};

export const initialState: DeliveryDetailUi = {
  deliveryDate: null,
  deliveryStartTime: null,
  deliveryEndTime: null,
  deliveryNotes: '',
  saveDisabled: false,
};
